import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=681e8ce2&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&id=681e8ce2&prod&lang=scss&"
import style1 from "./layout.vue?vue&type=style&index=1&id=681e8ce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e8ce2",
  null
  
)

export default component.exports